import { Injectable } from '@angular/core';
import { StorageKeys } from '../constants/storage-keys';
import { CurrentUser } from '../models/auth.model';

@Injectable({ providedIn: 'root' })
export class TokenService {
  getToken(): string | null {
    return sessionStorage.getItem(StorageKeys.accessToken);
  }

  setToken(token: string): void {
    sessionStorage.setItem(StorageKeys.accessToken, token);
  }

  clear(): void {
    sessionStorage.removeItem(StorageKeys.accessToken);
    sessionStorage.removeItem(StorageKeys.currentUser);
  }

  setCurrentUser(user: CurrentUser): void {
    sessionStorage.setItem(StorageKeys.currentUser, JSON.stringify(user));
  }

  getCurrentUser(): CurrentUser | null {
    const raw = sessionStorage.getItem(StorageKeys.currentUser);
    return raw ? JSON.parse(raw) as CurrentUser : null;
  }

  hasPermission(permission: string): boolean {
    return this.getCurrentUser()?.permissions.includes(permission) ?? false;
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }
}
